/**
 * MailtoParser JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class MailtoParser
 */
class MailtoParser {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.jsParseLinks = $( '.js-parse-link' );
    }

    /**
     *  This combines mailto-link data-prefix and data-suffix attributes as one value.
     *
     */
    combineDataToMailtoLink() {
        this.jsParseLinks.each( function() {
            let $dataprefix     = $( this ).attr( 'data-prefix' );
            let $datasuffix     = $( this ).attr( 'data-suffix' );
            let $printToElement = $( this ).attr( 'data-print' );
            let $mailto = $dataprefix + $datasuffix;
            $( this ).attr( 'href', 'mailto:' + $mailto );
            if ( $printToElement ) {
                $( this ).html( $mailto );
            }
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.combineDataToMailtoLink();
    }
}

// Export the class reference.
module.exports = MailtoParser;



// WEBPACK FOOTER //
// ./assets/scripts/mailtoparser.js